import { Component, OnInit } from '@angular/core';

//Imports Standalone
import { UserprofileComponent } from '../../userprofile/pages/userprofile.component';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.less'],
    imports: [
        UserprofileComponent
    ]
})
export class UserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
